import { render, staticRenderFns } from "./BarChartStackedYears.vue?vue&type=template&id=2a297ab0&"
import script from "./BarChartStackedYears.vue?vue&type=script&lang=js&"
export * from "./BarChartStackedYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports